import React from 'react';

import ChangePasswordSection from './ChangePasswordSection';

import styles from '../AccountSettingsPage.module.less';
import TwoFASection from './TwoFASection';

export default function SecurityPage() {
  return (
    <div className={styles.pageBox}>
      <ChangePasswordSection />
      <TwoFASection />
    </div>
  );
}
